export const COLLAPSABLE_BILL_DETAILS_TEST_IDS = {
    COLLAPSABLE_BILL_COLLAPSE_CTA: "collapsable_bill_detail_arrow",
    COLLAPSABLE_BILL_EXPANDED_CONTENT: "collapsable_bill_details_content_expended",
    COLLAPSABLE_BILL_COLLAPSED_CONTENT: "collapsable_bill_details_content_collapsed",
};
